export interface BranchNotFoundProps {
  message: string
}

export const useBranchNotFound = (props: BranchNotFoundProps) => {
  return {
    ...props,
  }
}
